import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "喵趣漫画需要付费吗？",
    a: "目前喵趣漫画的养猫日常、生活日常与日常趣事作品均可免费在线观看。轻松日常内容会持续更新，让每一位铲屎官都能随时随地方便地阅读，无需任何费用。",
  },
  {
    q: "喵趣漫画多久更新一次新作品？",
    a: "喵趣漫画的日常漫画作品基本保持每日或隔日更新，热门的喵趣漫画养猫日常作品更新更及时。你可以在首页「最新更新」区块第一时间看到新话内容，也可以收藏喜欢的作品方便追更。",
  },
  {
    q: "在手机和电脑上都能看吗？",
    a: "可以。喵趣漫画网采用响应式设计，无论你用手机、平板还是电脑，都能获得流畅舒适的阅读体验，随时随地在线看你的养猫日常漫画。",
  },
  {
    q: "我可以投稿自己的养猫漫画吗？",
    a: "非常欢迎！如果你也喜欢用漫画记录喵趣漫画日常、生活日常与日常趣事，可以通过页脚邮箱联系我们投稿合作。我们会认真阅读每一份作品，让更多养猫人看到你的创作。",
  },
  {
    q: "作品会永久保存吗？",
    a: "我们会长期维护平台上的日常漫画作品，并持续进行内容备份，确保你收藏和喜爱的养猫日常漫画能够稳定、长久地在线阅读。",
  },
  {
    q: "遇到无法播放或页面异常怎么办？",
    a: "如果遇到阅读异常，建议先刷新页面或清理浏览器缓存。若问题仍然存在，可通过页脚的联系邮箱反馈给我们，我们会尽快为你处理。",
  },
  {
    q: "如何保护创作者版权？",
    a: "喵趣漫画严格尊重每一位作者的版权，所有投稿作品均需作者授权后发布。若发现版权问题，请通过页脚邮箱与我们联系，我们会及时核实处理。",
  },
  {
    q: "支持哪些设备阅读？",
    a: "喵趣漫画支持主流的手机、平板、电脑以及各类浏览器，覆盖 iOS、Android、Windows 和 macOS 等系统，让你随时随地轻松追更养猫日常漫画。",
  },
];

export default function Faq() {
  useEffect(() => {
    document.title = "常见问题 - 喵趣漫画网 | 养猫日常漫画阅读帮助中心";
  }, []);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <section className="mx-auto max-w-4xl px-4 md:px-6 pt-28 pb-16 md:pb-20">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/10 text-accent-700 text-xs px-4 py-1.5">
            <i className="ri-question-line"></i> 帮助中心
          </span>
          <h1 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-950">
            常见问题
          </h1>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            关于喵趣漫画网的使用、追更与投稿问题，这里都有答案。如有其他疑问，欢迎通过页脚邮箱联系我们。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <details
              key={f.q}
              className="group rounded-2xl bg-background-100/70 border border-background-200 px-5 py-4 open:bg-background-100"
            >
              <summary className="flex items-center justify-between cursor-pointer list-none gap-4">
                <span className="flex items-center gap-3">
                  <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-700 text-xs shrink-0">
                    {i + 1}
                  </span>
                  <span className="font-medium text-foreground-950 text-sm md:text-base">
                    {f.q}
                  </span>
                </span>
                <i className="ri-add-line text-primary-600 group-open:rotate-45 transition-transform shrink-0"></i>
              </summary>
              <p className="mt-3 pl-10 text-sm text-foreground-700 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 text-background-50 p-8 text-center">
          <h2 className="font-heading text-2xl">还有疑问？</h2>
          <p className="mt-2 text-sm text-background-50/90 max-w-md mx-auto">
            没找到你想要的答案？随时联系我们，我们会尽快为你解答喵趣漫画日常相关的任何问题。
          </p>
          <button
            onClick={() => (window.location.href = "mailto:hello@miaoqucomic.example")}
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-background-50 text-primary-700 text-sm px-7 py-2.5 whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-mail-line"></i> 联系我们
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}